import cartApi from "@/api/cart";

const state = {
    isLoading: false,
    cart: null,
}
export const mutationTypes = {
    clearCart: '[cart] clearCart',
    setCart: '[cart] setCart',
    setIsLoading: '[cart] setIsLoading',
}
export const actionTypes = {
    getCart: '[cart] getCart',
}

export const getterTypes = {
    cart: '[cart] cart',
    isLoading: '[cart] isLoading'
}
const mutations = {
    [mutationTypes.setCart](state, cart) {
        state.cart = cart
    },
    [mutationTypes.clearCart](state){
        state.cart = null
    },
    [mutationTypes.setIsLoading](state, value){
        state.isLoading = value
    }
}

const getters = {
    [getterTypes.cart]: state => {
        return state.cart
    },
    [getterTypes.isLoading]: state => {
        return state.isLoading
    }
}

const actions = {
    [actionTypes.getCart](context, credentials) {
        context.commit(mutationTypes.setIsLoading, true)
        return new Promise(resolve => {
            cartApi
                .getCart(credentials)
                .then(response => {
                    context.commit(mutationTypes.setCart, response.data)
                    context.commit(mutationTypes.setIsLoading, false)

                    resolve(response.data['results'])
                })
                .catch(result => {
                    context.commit(mutationTypes.setIsLoading, false)
                    console.log('Result Errors:', result)
                })
        })
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}